(function () {
    angular
        .module('app')
        .controller('ApplicationEditorController', ApplicationEditorController);

    // Define controller dependencies.
    ApplicationEditorController.$inject = ['$q', '$rootScope', '$scope', 'LookupFactory', 'Restangular', 'SanitizerFactory'];

    /**
     * Controller for 'editor' view of 'master.application' state.
     *
     * @param $q
     * @param $rootScope
     * @param $scope
     * @param LookupFactory
     * @param Restangular
     * @constructor
     */
    function ApplicationEditorController($q, $rootScope, $scope, LookupFactory, Restangular, SanitizerFactory) {
        /**
         * --------------------------------------------
         * Private variables.
         * --------------------------------------------
         */

        /**
         * This controller.
         */
        var vm = this;

        /**
         * --------------------------------------------
         * Bindable members.
         * --------------------------------------------
         */

        /**
         * Bindable properties.
         */
        vm.partnerValues = undefined;
        vm.activeValues = undefined;

        /**
         * Bindable methods.
         */
        vm.browseLogo = browseLogo;
        vm.setPartnerValues = setPartnerValues;

        /**
         * --------------------------------------------
         * Private methods.
         * --------------------------------------------
         */

        /**
         * Initialize editor's data source.
         *
         * @returns Promise
         */
        function initialize() {
            $scope.shared.editor.initialized = false;

            vm.partnerValues = undefined;
            vm.activeValues = undefined;

            return $q.when()
                .then(setPartnerValues)
                .then(setActiveValues)
                .then(function () {
                    $scope.shared.editor.initialized = true;
                })
                .catch(function () {
                    return $q.reject();
                });

            function getResourceFieldValues(field) {
                return _.get(_.find($rootScope.global.resourceFields.application, {'name': field}), 'values');
            }

            function setActiveValues() {
                vm.activeValues = getResourceFieldValues('active');
                return $q.when();
            }
        }

        /**
         * Set default value for new resource.
         */
        function setNew() {
            if ($scope.shared.editor.initialized) {
                $scope.shared.editor.entity = {
                    id: undefined,
                    code: '',
                    name: '',
                    description: '',
                    app_url: '',
                    active: vm.activeValues[1].value,
                    logo: ''
                };
            }
        }

        /**
         * --------------------------------------------
         * Bindable member implementations.
         * --------------------------------------------
         */

        /**
         * Browse application logo.
         */
        function browseLogo() {
            helpers.chooseFile(function (files) {
                if (files && files[0]) {
                    var FR = new FileReader();
                    // Bring read string image into scope.
                    FR.onload = function (e) {
                        if (/^data:image\/(jpg|jpeg);base64,/.test(e.target.result)) {
                            $scope.shared.editor.entity.logo = e.target.result;
                        } else {
                            $scope.shared.editor.entity.logo = '';
                        }
                        $scope.$apply();
                    };
                    // Read image file as string.
                    FR.readAsDataURL(files[0]);
                }
            }, '.jpg,.jpeg', false);
        }

        /**
         * Set application's partner values.
         */
        function setPartnerValues() {
            vm.partnerValues = undefined;
            return Restangular.all('application').getList({q: {
                s: [{f: 'id'}, {f: 'code'}],
                o: [{f: 'code', o: 'asc'}]
            }})
                .then(function (result) {
                    vm.partnerValues = SanitizerFactory.sanitizeReceived(result.original);
                });
        }

        /**
         * --------------------------------------------
         * Controller activation.
         * --------------------------------------------
         */

        /**
         * Activate controller.
         */
        function activate() {
            $scope.shared.editor.initialize = initialize;
            $scope.shared.editor.setNew = setNew;

            $scope.$on('CRUDFactory.editSuccess', function (event, entity) {
                vm.partnerValues = entity.partnerObjects;
            });
        }

        activate();
    }
})();
